import "bootstrap-slider";
/* eslint-disable no-undef */
function calculatorResult(wrap, interestString) {
  if (!interestString) {
    return;
  }
  const interest = parseFloat(interestString.replace(",", "."));
  const result = ($(".slider-1", wrap).slider("getValue") / 100) * interest;
  $(".calculator__total > strong span", wrap).text(formatNumber(result));

  $(".calculator__action__money > strong span", wrap).text(
    formatNumber(result / 4)
  );
}

function calculatorInit() {
  const interest = $(".slider-1").data("interest");
  $(".calculator").each(function() {
    var thisCalc = this;
    $(".slider-1", thisCalc).slider({
      tooltip: "hide"
    });
    $(".label-1 > strong span", thisCalc).text(
      formatNumber($(".slider-1", thisCalc).slider("getValue"))
    );
    $(".slider-1", thisCalc).on("change", function(slideEvt) {
      $(".label-1 > strong span", thisCalc).text(
        formatNumber(slideEvt.value.newValue)
      );
      calculatorResult(thisCalc, interest);
    });

    calculatorResult(thisCalc, interest);
  });
}

function formatNumber(number) {
  var x = Number(number).toFixed(0);
  number = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "); // use space as thousand separator
  return number;
}

if ($(".calculator").length) {
  calculatorInit();
}

const investedInput = document.getElementById("invested-slider");
const timeInput = document.getElementById("time-slider");
const investedNumber = document.getElementById("invested-number");
const timeNumber = document.getElementById("time-number");
const totalAmount = document.getElementById("total-amount");
const yieldAmount = document.getElementById("yield");
const yieldPercent = document.getElementById("yield-percent");

if (investedInput && timeInput) {
  investedInput.addEventListener("input", calcInvested);
  timeInput.addEventListener("input", calcTime);
}

function calcInvested(e) {
  investedNumber.innerHTML = e.target.value
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  calcNumbers(e);
}

function calcTime(e) {
  timeNumber.innerHTML = e.target.value
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  calcNumbers(e);
}

function calcNumbers(e) {
  e.target.nextElementSibling.style.width = `${map_range(e.target)}%`;
  var ammount;
  let ammountNoVat = +investedInput.value * Math.pow(1.075, timeInput.value);
  if (timeInput.value < 3) {
    ammountNoVat = ammountNoVat * 0.9;
  }

  if (ammountNoVat - +investedInput.value < 0) {
    ammount = Math.ceil(ammountNoVat - +investedInput.value);
  } else {
    if (timeInput.value > 2) {
      ammount = Math.ceil(ammountNoVat - +investedInput.value);
    } else {
      ammount = Math.ceil((ammountNoVat - +investedInput.value) * 0.85);
    }
  }
  totalAmount.innerHTML = (+investedInput.value + ammount)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  yieldAmount.innerHTML = ammount
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  yieldPercent.innerHTML = (
    Math.round((ammount / investedInput.value) * 1000) / 10
  ).toLocaleString("cs-CZ");
}

function map_range(e) {
  return (100 * (e.value - e.min)) / (e.max - e.min);
}
